var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-status',{staticClass:"report-cert-result"},[_c('page-result',{attrs:{"image":_vm.content.image,"title":_vm.content.title,"desc":_vm.content.desc}},[_c('div',{staticClass:"result-qrcode"},[_c('miniapp-qrcode')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }